export default (props = {}) => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M12.5631 8.61541L7.9614 13.2171L6.5791 11.8343L9.79804 8.61491L6.5791 5.39597L7.9614 4.01367L12.5631 8.61541Z" fill="currentColor"/>
</svg>
